var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoctorAvatarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 82
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE8E7",
    d: "M48.8 34.776c9.95 4.95 16.8 15.32 16.8 27.311 0 16.793-60 16.793-60 0 0-11.538 6.341-21.575 15.684-26.726l13.413 15.2zm-13.2-3.094c4.19 0 8.179.87 11.8 2.442H23.8a29.555 29.555 0 0111.8-2.442z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0F0238",
    strokeWidth: 2.4,
    d: "M67.6 65.916c0-18.355-14.998-33.234-33.5-33.234-18.502 0-33.5 14.88-33.5 33.234s67 18.354 67 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.6,
    cy: 19.682,
    r: 19,
    fill: "#FFF",
    stroke: "#0F0238",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    stroke: "#0F0238",
    strokeWidth: 2.4,
    d: "M33.516.682c1.767 0 3.474.282 5.084.807-1.424 8.084-7.97 14.193-15.829 14.193-2.185 0-4.27-.473-6.17-1.328C18.776 6.446 25.526.682 33.516.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    stroke: "#0F0238",
    strokeWidth: 2.4,
    d: "M37.297.682a12.89 12.89 0 00-3.697.538c1.035 5.39 5.796 9.462 11.512 9.462 1.59 0 3.106-.315 4.489-.886A12.838 12.838 0 0037.297.682z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0F0238",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "M42.1 65.182v-6c0-2.21 1.79-4 4-4h7c2.21 0 4 1.79 4 4v6h0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.1,
    cy: 60.182,
    r: 4.5,
    stroke: "#0F0238",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0F0238",
    strokeWidth: 2.4,
    d: "M18.1 38.5v16.364m31-16.364v16.364"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81-18h231v119H-81z"
  }))));
}

export default SvgDoctorAvatarIcon;